import React from 'react';
import BasicInformationSection from './BasicInformationSection';
import ContactInformationSection from './ContactInformationSection';
import MapSection from './MapSection';
import PaymentMethodSection from './PaymentMethodSection';
import BusinessHoursSection from './BusinessHoursSection';

export default function EssentialSectionsWrapper({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
  shopTypes,
  stateRef,
  mapContainerStyle,
  mapOptions,
  currentLocation,
  paymentMethods,
  handlePaymentMethodChange,
  handlePaymentUrlChange,
  addBankAccount,
  removeBankAccount,
  businessHours,
  handleBusinessHoursChange,
  daysOfWeek,
  setupCompleted
}) {


  return (
    <div className="essential-sections-container">
      <BasicInformationSection
        values={values}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
        handleBlur={handleBlur}
        setFieldValue={setFieldValue}
        shopTypes={shopTypes}
      />

      <MapSection
        values={values}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
        setFieldValue={setFieldValue}
        stateRef={stateRef}
        mapContainerStyle={mapContainerStyle}
        mapOptions={mapOptions}
        currentLocation={currentLocation}
        shopMarkerPosition={values.markerPosition}
      />

      <ContactInformationSection
        values={values}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
        setFieldValue={setFieldValue}
      />

    </div>
  );
}